import { render, staticRenderFns } from "./DetailedRawTK.vue?vue&type=template&id=1910ae48"
import script from "./DetailedRawTK.vue?vue&type=script&lang=js"
export * from "./DetailedRawTK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports